import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const queryChargeCardPaymentOptions = gql`
  query ChargeCardPaymentOptions($id: ID!) {
    chargeCardPaymentOptions {
      sources {
        __typename
        id
        title
        description
        options {
          id
          isRecommended
          description
          frequency
          amount {
            ...money
          }
        }
      }
    }
    user {
      customerInfo {
        id
        name {
          full
        }
      }
    }
    accountR2(id: $id) {
      ... on InternalChargeCardAccount {
        id
        action {
          type
        }
      }
    }
  }
  ${money}
`;

export default queryChargeCardPaymentOptions;
